function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { UnstyledUncontrolledAccordion } from "../accordion/UnstyledUncontrolledAccordion";
import { useChildrenProps } from "../../../hook/ui/common/children/useChildrenProps";

/*
    Returns a collapsible group of links

    props
        (component, optional) AccordionComponent  The UNCONTROLLED accordian component to use
        (object, optional)    linkProps           An object of props that is passed to every child component (link)
        (children)            children            The links to show in the collapsible section of the accordion
        (prop)                rest                Any other props are passed to the AccordionComponent
*/

const UnstyledLinkAccordionGroup = ({
  classPrepend = "unstyled",
  className = "",
  AccordionComponent = UnstyledUncontrolledAccordion,
  onSeletedChange = null,
  linkProps = {},
  children,
  ...rest
}) => {
  const [childrenWithProps] = useChildrenProps(children, {
    classPrepend,
    ...linkProps
  });
  return /*#__PURE__*/React.createElement(AccordionComponent, _extends({
    classPrepend: classPrepend
  }, rest), childrenWithProps);
};
export { UnstyledLinkAccordionGroup };